import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
const TABS = [
    { value: 'offers', label: 'Offer list', icon: faList },
    { value: 'calendar', label: 'Availability index', icon: faCalendarDays }
];
// Switches between the two views over one search: the grouped offer list and
// the day-by-day availability calendar.
export const ViewToggle = ({ view, onChange }) => (_jsx("div", { role: "tablist", "aria-label": "Result view", className: "inline-flex rounded-lg border border-base-300 bg-base-100 p-1", children: TABS.map(tab => {
        const active = tab.value === view;
        return (_jsxs("button", { type: "button", role: "tab", "aria-selected": active, onClick: () => onChange(tab.value), className: `flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium ${active
                ? 'bg-pool/40 text-midnight'
                : 'text-light-midnight hover:text-midnight'}`, children: [_jsx(FontAwesomeIcon, { icon: tab.icon }), tab.label] }, tab.value));
    }) }));
